import { createSlice } from '@reduxjs/toolkit';

import { logout } from '../auth/index';

const initialState = {
  messages: undefined,
  files: [],
  selectedGroup: undefined,
  receiver: undefined,
  groupChats: [],
  groupUnread: undefined,
  onlineChange: undefined,
  updateGroupUnread: undefined,
  userUnread: undefined,
  updatedGroup: undefined,
};

const MessagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    setMessages: (state, action) => {
      if (Array.isArray(state.messages)) {
        let newMessage = [...action.payload, ...state.messages];
        newMessage = newMessage.filter(
          (item, pos) =>
            newMessage.findIndex((x) => x._id === item?._id) === pos,
        );
        state.messages = newMessage;
      } else {
        state.messages = action.payload;
      }
    },
    resetMessage: (state, action) => {
      state.messages = action.payload;
    },
    setMessage: (state, action) => {
      const groupId = sessionStorage.getItem('selectedGroup');
      if (action.payload?.group === groupId) {
        if (Array.isArray(state.messages)) {
          let newMessage = [...state.messages, action.payload];
          newMessage = newMessage.filter(
            (item, pos) =>
              newMessage.findIndex((x) => x._id === item?._id) === pos,
          );
          state.messages = newMessage;
        } else {
          state.messages = [action.payload];
        }
      }
    },
    setFiles: (state, action) => {
      state.files = action.payload;
    },
    setSelectedGroup: (state, action) => {
      state.selectedGroup = action.payload;
      sessionStorage.setItem('selectedGroup', action.payload?._id || '');
    },
    setReceiver: (state, action) => {
      state.receiver = action.payload;
    },
    setGroupChats: (state, action) => {
      state.groupChats = action.payload;
    },
    setOnlineChange: (state, action) => {
      state.onlineChange = action.payload;
    },
    setGroupUnread: (state, action) => {
      state.groupUnread = action.payload;
    },
    setUpdateUnread: (state, action) => {
      const groupId = sessionStorage.getItem('selectedGroup');
      if (action.payload?.group === groupId) {
        state.updateGroupUnread = Date.now();
      }
    },
    setUserUnread: (state, action) => {
      state.userUnread = action.payload;
    },
    setUpdatedGroup: (state, action) => {
      state.updatedGroup = action.payload;
    },
  },
  extraReducers: {
    [logout]: (state) => initialState,
  },
});

export const {
  setMessages,
  setMessage,
  setSelectedGroup,
  setReceiver,
  setGroupChats,
  resetMessage,
  setOnlineChange,
  setGroupUnread,
  setUpdateUnread,
  setUserUnread,
  setUpdatedGroup,
} = MessagesSlice.actions;

export const getMessages = (state) => state.messages.messages;
export const getFiles = (state) => state.messages.files;
export const getSelectedGroup = (state) => state.messages.selectedGroup;
export const getReceiver = (state) => state.messages.receiver;
export const getGroupChats = (state) => state.messages.groupChats;
export const getOnlineChange = (state) => state.messages.onlineChange;
export const getGroupUnread = (state) => state.messages.groupUnread;
export const getUpdateGroupUnread = (state) => state.messages.updateGroupUnread;
export const getUserUnread = (state) => state.messages.userUnread;
export const getUpdatedGroup = (state) => state.messages.updatedGroup;

export default MessagesSlice.reducer;
